module.exports = __webpack_public_path__ + "img/Machine1.b6630b35.svg";